import { render } from "./AddNewProductCategories.vue?vue&type=template&id=8b00212e&scoped=true"
import script from "./AddNewProductCategories.vue?vue&type=script&lang=js"
export * from "./AddNewProductCategories.vue?vue&type=script&lang=js"

import "./AddNewProductCategories.vue?vue&type=style&index=0&id=8b00212e&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b00212e"]])

export default __exports__